import { render, staticRenderFns } from "./loading-animation.html?vue&type=template&id=39956b24&scoped=true&"
import script from "./loading-animation.js?vue&type=script&lang=js&"
export * from "./loading-animation.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39956b24",
  null
  
)

export default component.exports